<div class="login-container">
    <mat-card appearance="outlined" class="box">
        <div class="version">v{{ version }}</div>
        <form class="form-container" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <fa-icon class="authenticate-icon" [icon]="fakey"></fa-icon>

            <a class="link" role="button" (click)="forgottenPassword()">{{ 'Login.PasswordLink' | translate }}</a>

            <mat-form-field>
                <mat-label>{{ 'Login.InputUsernamePlaceholder' | translate }}</mat-label>
                <input matInput formControlName="username" autocomplete="false" required />
                <mat-error>{{ 'Login.InputUsernameErrorMessage' | translate }}</mat-error>
            </mat-form-field>

            <mat-form-field color="accent">
                <mat-label>{{ 'Login.InputPasswordPlaceholder' | translate }}</mat-label>
                <input [type]="hide ? 'password' : 'text'" matInput formControlName="password" autocomplete="false" required />
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" type="button">
                    <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <mat-error>{{ 'Login.InputPasswordErrorMessage' | translate }}</mat-error>
            </mat-form-field>

            <div class="submit-container">
                <button mat-raised-button color="accent" [disabled]="!loginForm.valid" type="submit">{{ 'Login.SubmitButton' | translate }}</button>
                @if (authenticationInvalid) {
                <mat-error>{{ 'Login.AuthentificationInvalidMessage' | translate }}</mat-error>
                }
            </div>
        </form>
    </mat-card>
</div>
